import { PortableText } from '@portabletext/react'
import React from 'react'
import { BigReviews } from './BigReviews'
import { PORTABLE_COMPONENTS } from '../../lib/helper/portableTextHelpers'

type Props = {
  description: RichText[]
  stars?: number
  numberOfReviews?: number
  nameLocation?: string
  nameEntity?: string
  withBorder?: boolean
  noTopMargin?: boolean
  suffix?: React.ReactNode
}

export function Description({
  description,
  withBorder,
  suffix,
  noTopMargin,
  ...props
}: Props) {
  const classes = `${withBorder ? 'gyg-widget-copy' : ''} mx-3 xs:mx-0 ${noTopMargin ? 'mb-10' : 'my-10'} xs:my-10`

  // Process description array to change h2 to h3 for all occurrences except the first one
  const processedDescription = React.useMemo(() => {
    let firstNonHighlightsH2Found = false

    // First pass: handle the first h2 occurrence and highlights h2s
    let processed = description.map((item) => {
      if (item.style === 'h2') {
        // Check if the text contains " - Highlights"
        const hasHighlightsText = item.children?.some(
          (child: any) => child.text && child.text.includes(' - Highlights'),
        )

        if (hasHighlightsText) {
          return item // Keep highlights h2s as h2
        } else if (!firstNonHighlightsH2Found) {
          firstNonHighlightsH2Found = true
          return item // Keep the first non-highlights h2 as h2
        } else {
          return { ...item, style: 'h3' } // Change subsequent non-highlights h2s to h3
        }
      }
      return item
    })

    return processed
  }, [description])

  return (
    <div className={`xs:my-10 ${classes} portableText`}>
      <PortableText
        value={processedDescription}
        components={PORTABLE_COMPONENTS}
      />
      <BigReviews {...props} />
      <div className="w-full xs:flex xs:justify-center">{suffix}</div>
    </div>
  )
}
